import axios, { InternalAxiosRequestConfig } from 'axios'

import { GLOBAL_URL } from 'external/environment'


axios.defaults.baseURL = GLOBAL_URL;

const updateHeader = (request: InternalAxiosRequestConfig<any>) => {
	request.headers['Content-Type'] = 'application/json'
	return request;
}

axios.interceptors.request.use(updateHeader)

axios.interceptors.response.use(
	r => r,
	e => {
		console.log('error_', getValidationError(e.code));
		return Promise.reject(e);
	}
)

function getValidationError (error: string | number) {
	const codeMatcher = {
		ERR_NETWORK: 'Bad Network',
		ERR_BAD_RESPONSE: 'Bad Response',
	};

	return codeMatcher[error]
}

const get = axios.get.bind(axios)
const post = axios.post.bind(axios)
const remove = axios.delete.bind(axios)

export {get, post, remove}